/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable no-var */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */


import Programas_FrontAPI, { IRetornoAjaxProgramas } from './Programas_FrontAPI';
import { useAppContextoReact } from '../app/AppContextoReact';
import { DataType, IFormStatePrograma } from '../IFormularios';
import { IPropsFilterObj } from '../../componentes/tabelas/TableFilter';
import { Order } from 'src/componentes/tabelas/ITabelas';

export default class ProgramasController extends Programas_FrontAPI
{
    public appContext = useAppContextoReact();
    
    //#region PROGRAMAS [LIST, CREATE, UPDATE, DELETE]

        async programasList(idPrograma?:number,callbackDataFilter?:IPropsFilterObj,rowsNum?:number,pageNum?:number,orderBy?:string,order?:Order,sortParameter?:string)
        {
            try
            {
                const token:string|undefined = await this.appContext.usuario.user.getIdToken();

                if(sortParameter === 'serie.titulo')
                    sortParameter = 'serieTitulo';

                // console.log('sortParameter:', sortParameter);
                if(token)
                {
                    const res:IRetornoAjaxProgramas = await this.programasListaAjax(token,idPrograma,callbackDataFilter,rowsNum,pageNum,orderBy,order,sortParameter);

                    return res;
                }
            }
            catch(e)
            {
                return e;
            }
        } 
        
        async programaCreate(data:FormData)
        {
            let retorno: IRetornoAjaxProgramas;

            try
            {
                const token:string|undefined = await this.appContext.usuario.user.getIdToken();

                if(token)
                {
                    retorno = await this.programaCreateAjax(token,data);

                    return retorno;
                }
            }
            catch(e)
            {
                return e;
            }
        }               

        async programaUpdate(data:FormData,type:DataType)
        {
            let retorno: IRetornoAjaxProgramas;

            try
            {
                const token:string|undefined = await this.appContext.usuario.user.getIdToken();

                if(token)
                {
                    retorno = await this.programaUpdateAjax(token,data,type);

                    return retorno;
                }
            }
            catch(e)
            {
                return e;
            }
        }

        /*
        async programaAnexosUpdate(data:FormData,type:DataType)
        {
            let retorno: IRetornoAjaxProgramas;

            try
            {
                const token:string|undefined = await this.appContext.usuario.user.getIdToken();

                if(token)
                {
                    retorno = await this.programaUpdateAjax(token,data,type);

                    return retorno;
                }
            }
            catch(e)
            {
                return e;
            }
        }
        */

        async programasDelete(idPrograma:string)
        {
            let retorno: IRetornoAjaxProgramas;

            try
            {
                const token:string|undefined = await this.appContext.usuario.user.getIdToken();

                if(token)
                {
                    retorno = await this.programaDeleteAjax(token,idPrograma);

                    return retorno;
                }
            }
            catch(e)
            {
                return e;
            }
        }

    //endregion
}